export enum BadgeTypes {
  Triangle = 'triangle',
  Bookmark = 'bookmark',
}

export class Badge {
  public text: string;
  public type: BadgeTypes;

  constructor(data: Badge) {
    Object.assign(this, data);
  }
}
